export enum UserRole {
  ROLE_ADMIN = "ROLE_ADMIN",
  ROLE_USER = "ROLE_USER",
  ROLE_VIEW_ONLY_USER = "ROLE_VIEW_ONLY_USER",
  ROLE_SOLAR_DASHBOARD_ADMIN = "ROLE_SOLAR_DASHBOARD_ADMIN",
}
